import { config } from '@v4/config';

/**
 * Checks whether or not the currency has a prefix
 *
 * @param {String} locale
 * @returns {Boolean}
 */
export const hasSignPrefix = (lang) => ['it-IT', 'en-GB', 'tr-TR'].includes(lang ? lang : document.documentElement.lang);

/**
 * Returns the currency sign based on locale
 *
 * @param {String} locale
 * @returns {String} currency sign
 */
export const getCurrencySign = () => '€';

/**
 * Returns the currency code based on locale
 *
 * @param {String} locale
 * @returns {String} currency code
 */
export const getCurrencyCode = () => 'EUR';
